import {FC, useMemo} from 'react'
import {ID} from '../../../../../_metronic/helpers'
import {useKTable} from '../../../contexts/KTableProvider'
type Props = {
  id: ID
  clickHandler?: (id: ID) => void // Define la propiedad onClick
  disable?: boolean
}

const KTableSelectionCellNonMultiple: FC<Props> = ({id, clickHandler, disable, ...props}) => {
  const {selectedOn, onlySelect} = useKTable()
  const isSelected = useMemo(() => selectedOn.includes(id), [id, selectedOn])

  const handleChangeSelect = (id: any) => {
    onlySelect(id)
    if (clickHandler) {
      clickHandler(id)
    }
  }
  return (
    <>
      <div className='form-check form-check-custom form-check-solid ps-4'>
        <input
          className='form-check-input border border-gray-500'
          type='checkbox'
          data-kt-check={isSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isSelected}
          onChange={() => handleChangeSelect(id)}
          disabled={disable}
        />
      </div>
    </>
  )
}

export {KTableSelectionCellNonMultiple}
